// * External menu
const WPM_CUSTOMER_DETAIL = {
  title: "My Contract",
  route: "externalCustomerDetail",
  icon: "UserIcon",
}
const WPM_TICKET_MANAGEMENT_MENU = {
  title: "Ticket Management",
  route: "externalTicketManagement",
  icon: "TagIcon",
}
const WPM_QR_ACCESS_MANAGEMENT_MENU = {
  title: "Site Access",
  route: "externalSiteAccessManagement",
  icon: "MaximizeIcon",
}
const WPM_SMART_HAND_MENU = {
  title: "Smart Hand",
  route: "externalSmartHand",
  icon: "ThumbsUpIcon",
}
const WPM_PARCEL_TRACKING_MENU = {
  title: "Parcel Tracking",
  route: "externalParcelTracking",
  icon: "TruckIcon",
}
const WPM_CROSS_CONNECT_MENU = {
  title: "Cross Connect",
  route: "externalCrossConnect",
  icon: "LinkIcon",
}

// * Internal menu
const INTERNAL_WPM_TICKET_MANAGEMENT_MENU = {
  title: "Ticket Management",
  route: "internalTicketManagement",
  icon: "TagIcon",
}

const INTERNAL_WPM_SITE_ACCESS_MANAGEMENT_MENU = {
  title: "Site Access",
  icon: "MaximizeIcon",
  children: [
    {
      title: "Dashboard",
      route: "internalSiteAccessDashboard",
    },
    {
      title: "Access List",
      route: "internalSiteAccessManagement",
    },
  ],
}
const INTERNAL_WPM_INVENTORY_MENU = {
  title: "Inventory",
  route: "internalInventory",
  icon: "BriefcaseIcon",
}
const INTERNAL_WPM_SMART_HAND_MENU = {
  title: "Smart Hand",
  route: "internalSmartHand",
  icon: "ThumbsUpIcon",
}
const INTERNAL_WPM_PARCEL_TRACKING_MENU = {
  title: "Parcel Tracking",
  route: "internalParcelTracking",
  icon: "TruckIcon",
}
const INTERNAL_WPM_CROSS_CONNECT_MENU = {
  title: "Cross Connect",
  route: "internalCrossConnect",
  icon: "LinkIcon",
}
const INTERNAL_WPM_IDC_MENU = {
  title: "NTDC Database",
  icon: "DatabaseIcon",
  children: [
    {
      title: "Contract",
      route: "internalIdc",
    },
    {
      title: "Customer",
      route: "idcCustomer",
    },
    {
      title: "Contact Point & Sale",
      route: "idcContact",
    },
    {
      title: "Attachment",
      route: "internalPortalAttachmentManagement",
    },
  ],
}
const INTERNAL_WPM_IP_ADDRESS_MANAGEMENT_MENU = {
  title: "IP Address Manager",
  route: "ipamManagement",
  icon: "HashIcon",
}
const INTERNAL_REPORT_MENU = {
  title: "Report",
  route: "webPortalReport",
  icon: "FileTextIcon",
}

// Workload
const INTERNAL_WORKLOAD_MENU = {
  title: "Workload",
  route: "internalWebPortalWorkload",
  icon: "ClockIcon",
}

const INTERNAL_ESCALATION_MENU = {
  title: "Escalation",
  icon: "ChevronsUpIcon",
  isActive: true,
  children: [
    {
      title: "Escalation Template",
      route: "escalationTemplate",
    },
    {
      title: "Escalation Events",
      route: "escalationEvents",
    },
  ],
}
const INTERNAL_WPM_DASHBOARD_MENU = {
  title: "Dashboard",
  route: "internalPortalDashboard",
  icon: "GridIcon",
}
const INTERNAL_WPM_EXECUTIVE_DASHBOARD_MENU = {
  title: "Executive View",
  route: "internalPortalExecutiveDashboard",
  icon: "GridIcon",
}

export {
  WPM_CUSTOMER_DETAIL,
  WPM_TICKET_MANAGEMENT_MENU,
  WPM_QR_ACCESS_MANAGEMENT_MENU,
  WPM_SMART_HAND_MENU,
  WPM_PARCEL_TRACKING_MENU,
  WPM_CROSS_CONNECT_MENU,
  INTERNAL_WPM_TICKET_MANAGEMENT_MENU,
  INTERNAL_WPM_SITE_ACCESS_MANAGEMENT_MENU,
  INTERNAL_WPM_INVENTORY_MENU,
  INTERNAL_WPM_SMART_HAND_MENU,
  INTERNAL_WPM_PARCEL_TRACKING_MENU,
  INTERNAL_WPM_CROSS_CONNECT_MENU,
  INTERNAL_WPM_IDC_MENU,
  INTERNAL_WPM_IP_ADDRESS_MANAGEMENT_MENU,
  INTERNAL_REPORT_MENU,
  INTERNAL_ESCALATION_MENU,
  INTERNAL_WPM_DASHBOARD_MENU,
  INTERNAL_WPM_EXECUTIVE_DASHBOARD_MENU,
  INTERNAL_WORKLOAD_MENU,
}
